import { useTranslation } from "react-i18next";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const SkillsPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("skills");
  const { addObject, handleSelectObject } = useStorageObject(
    "skills",
    "skills",
    currentService,
  );
  const { t } = useTranslation();
  useServiceNavigate("skills", "skills");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => addObject(t("skills.default_name"), "child")}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"skills"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
